import React from "react";
import "./index.css";
import cn from "classnames";

export const InfoCard = ({children, className}) => {
  const infoCardClasses = cn("infocard", className);

  return <div className={infoCardClasses}>{children}</div>;
};
